import { LANDING_PAGE_URL } from "config";

export function getUrlToLoginPage() {
  return "/login";
}

export function getUrlToPhoneLoginPage() {
  return "/phone";
}

export function getUrlToSignupPage() {
  return "/signup";
}

export function getUrlToLoginCallbackPage() {
  return "/login/callback";
}

export function getUrlToManagePage() {
  return "/manage";
}

export function geturlToLogoutPage() {
  return "/logout";
}

export function getUrlToLandingPage() {
  return LANDING_PAGE_URL;
}

export function getUrlToTermsAndConditionsPage() {
  return "/terms-and-conditions";
}

export function getUrlToPrivacyPolicyPage() {
  return "/terms-and-conditions";
}

export function getUrlToAboutUsPage() {
  return "/about-us";
}

export function getUrlToGoogleLoginPage () {
  return "/login/google"
}

export function getUrlToGoogleLoginCallbackPage () {
  return "/login/google/callback"
}

export function getUrlToForgotPasswordPage () {
  return "/forgot-password"
}
